module.exports = __webpack_public_path__ + "static/img/cd_yy_disabled.68e81db5.png";